import { useContext } from 'react'
import FeatureFlagsContext, { FeatureFlagsContextType } from './FeatureFlags.context'

export function useFeatureFlags(): FeatureFlagsContextType {
  return useContext(FeatureFlagsContext)
}
